// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    // Compare Vehicle Listings
    initCompareListings();
}]);

// Vehicle Comparison functions
window.initCompareListings = function initCompareListings() {

    // Hide/Show compare items
    $('.btn-compare-show').on('click', function() {

        var target = $(this).data('target')

        // reset active button states
        $('.btn-compare-show').removeClass('active');

        // set active button state
        $(this).addClass('active');

        // hide others
        $('.compare-show').addClass('d-none').removeClass('d-table-cell');

        // show target
        $(target).addClass('d-table-cell').removeClass('d-none');

    });

    // on window resize reset visibility
    $(window).on('resize', function() {
        var width = $(window).width();

        if (width > 767) {
            // show all
            $('.compare-show').addClass('d-table-cell').removeClass('d-none');

        } else {
            // hidden-xs, hide all except for the active one
            // $('.compare-show').addClass('hidden-xs').removeClass('visible-xs');

            // get active tab class and show that one
            var activeTab = $('.btn-compare-show.active');
            activeTab.trigger('click');

            // default show first car
            // $('.compare-show-1').removeClass('hidden-xs').addClass('visible-xs')

            // reset button states
            // $('.btn-compare-show').removeClass('active');
            // $('#btn-compare-show-1').addClass('active');
        }
    });


    // get savedlistings to compare from cookie
    var savedlistings = Cookies.get('comparelistings');
    var comparelistings = [];
    // Compare Listings
    $('#wrapper').on('click', '.comparelisting', function() {

        var listingid = $(this).val();

        if (comparelistings.length >= 3 && comparelistings.indexOf(listingid) === -1) {
            alert('You can only compare a maximum of 3 cars!\n\nPlease remove at least one from your compare list to add this vehicle.');
            return false;
        }

        if ($(this).is(':checked')) {
            // add product to array cookie
            if (comparelistings.indexOf(listingid) === -1) {
                comparelistings.push(listingid);
            }
            // json = JSON.stringify(comparelistings);
            // console.log('JSON : ', json);
        } else {
            // remove from array cookie
            comparelistings.pop(listingid);
        }

        // console.log('saved listings ', comparelistings);

        // save cookie as JSON string
        Cookies.set('comparelistings', JSON.stringify(comparelistings));

        updateNumCompareListings();
    });

    function updateNumCompareListings() {
        // get savedlistings to compare from cookie
        savedlistings = Cookies.get('comparelistings');

        // check if cookie exists
        if (typeof savedlistings !== "undefined") {
            // console.log('we have a cookie set');

            // convert JSON str to array
            comparelistings = $.parseJSON(savedlistings);

        } else {
            // console.log('cookie not set');

        }
        // console.log('saved listings ', comparelistings);

        // count listings
        var numlistings = comparelistings.length;
        $('.num-compared').text(numlistings);

        // show or hide the compare button
        if (numlistings > 0) {
            $('.compare-action').removeClass('down').addClass('up');
            $('.compare-btn').removeClass('hide');

            // new footroom
            // if ($('#footroom').hasClass('footroom--unpinned')) {
            //     $('.compare-action').removeClass('higher');
            // } else {
            //     $('.compare-action').addClass('higher');
            // }
        } else {
            $('.compare-action').addClass('down').removeClass('up').removeClass('higher');
            $('.compare-btn').addClass('hide');
        }
    }

    // set default number of products
    updateNumCompareListings();

    $('.remove-comparelisting').on('click', function(e) {
        e.preventDefault();

        // get savedlistings to compare from cookie
        savedlistings = Cookies.get('comparelistings');

        // check if cookie exists
        if (typeof savedlistings !== "undefined") {

            // convert JSON str to array
            var comparelistings = $.parseJSON(savedlistings);
            var listingid = $(this).data('listingid');
            // console.log('removing ', listingid);
            // remove from array cookie
            comparelistings.pop(listingid);
            // console.log(comparelistings);
            // save cookie as JSON string
            Cookies.set('comparelistings', JSON.stringify(comparelistings));
            // console.log(Cookies.get('comparelistings'));

            document.location.reload();
            // delete
            // $(this).parents('.compare-item').slideUp(1000, function() {
            //     $(this).remove();
            // });

        }
    });
    $('.remove-all-compare-vehicles').on('click', function(e) {
        e.preventDefault();
        if (confirm('Are you sure you want to remove all vehicles from your comparison list?')) {
            // untick all
            $('.comparelisting').prop('checked', false);

            // empty cookie
            Cookies.remove('comparelistings');
            $('.compare-action').addClass('down').removeClass('up');
            comparelistings = [];

            updateNumCompareListings();
        }
    });
    $('.btn-exitcomparison').on('click', function(event) {
        event.preventDefault();
        window.history.back();
    });
}